import { render, staticRenderFns } from "./tnc-pk.vue?vue&type=template&id=e7d89260&scoped=true"
import script from "./tnc-pk.vue?vue&type=script&lang=js"
export * from "./tnc-pk.vue?vue&type=script&lang=js"
import style0 from "./tnc-pk.vue?vue&type=style&index=0&id=e7d89260&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d89260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7d89260')) {
      api.createRecord('e7d89260', component.options)
    } else {
      api.reload('e7d89260', component.options)
    }
    module.hot.accept("./tnc-pk.vue?vue&type=template&id=e7d89260&scoped=true", function () {
      api.rerender('e7d89260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-pk.vue"
export default component.exports